/* PDP -ugc1 accessory cross-sell: "Add +" adds the accessory to cart via AJAX,
   shows an "Added ✓" confirmation, and updates the header cart-count bubble.
   Tile/image clicks fall through to the product link untouched. */
(function () {
  'use strict';

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      var visible = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
      if (visible) visible.textContent = count;
      bubble.classList.toggle('cart-count-bubble--empty', count === 0);
    });
    // also reveal an empty cart icon's bubble if the theme hides it at 0
    var icon = document.getElementById('cart-icon-bubble');
    if (icon && count > 0 && !icon.querySelector('.cart-count-bubble')) {
      var b = document.createElement('div');
      b.className = 'cart-count-bubble';
      b.innerHTML = '<span aria-hidden="true">' + count + '</span>';
      icon.appendChild(b);
    }
  }

  function flash(btn, label, cls) {
    btn.textContent = label;
    if (cls) btn.classList.add(cls);
    setTimeout(function () {
      btn.textContent = 'Add +';
      if (cls) btn.classList.remove(cls);
      btn.disabled = false;
    }, 1600);
  }

  function addToCart(btn) {
    if (btn.disabled || btn.classList.contains('is-added')) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        if (cart) updateCartCount(cart.item_count);
        // let any theme cart UI know something changed
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        flash(btn, 'Added ✓', 'is-added');
      })
      .catch(function () { flash(btn, 'Try again'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pug-add]');
    if (!btn) return;
    e.preventDefault();   // the card is an <a>; don't navigate when adding
    e.stopPropagation();
    addToCart(btn);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest('[data-pug-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });
})();
